import { Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as TransactionActions from "../../store/transaction/actions";
import { ItransactionData } from "../../store/transaction/types";
import TransactionNotMineDialog from "../Dialogs/TransactionNotMineDialog";
import { DialogComponent } from "./../common/DialogComponent";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { getFormattedDate } from "../../util/dateFormatting";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useAreServicesActive } from "../../util/CommonServices";
import { enableMXForIDF, ezsServiceIds } from "../../config/UserServicesList";
import * as services from "../../store/service";

const TransactionActivity = () => {
    // default
    const [pageSize, setPageSize] = useState(10);
    const filterAccountType = [
        { name: "All Account Types", value: "", key: "AllACType99" },
        { name: "Bank Accounts", value: "1", key: "BankACType1" },
        { name: "Credit Card", value: "2", key: "CreditCardACType1" },
        { name: "Investment Accounts", value: "3", key: "InvestmentACType1" },
    ];

    // variable - chart
    const initialTransactionData: ItransactionData = {
        "account-id": "0",
        "account-name": "",
        "account-nickname": "",
        "account-number": "",
        "category-name": "",
        "is-fraudulent-transaction": "0",
        "is-triggered-alert": "0",
        "transaction-date": "",
        "transaction-id": "",
        amount: 0,
        description: "",
        id: 0,
        merchant: "",
        "transaction-type": "",
    };
    const minFilterDate = "";
    const maxFilterDate = "";
    // useState
    const [showTransactionNotMineDialog, setShowTransactionNotMineDialog] = useState(false);
    const [isNotMine, setIsNotMine] = useState(false);
    const [transaction, setTransaction] = useState(initialTransactionData);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterStartDate, setFilterStartDate] = useState(minFilterDate);
    const [filterEndDate, setFilterEndDate] = useState(maxFilterDate);
    const [filterAccountId, setFilterAccountId] = useState("");
    const [selectedBankAccountTypeId, setSelectedBankAccountTypeId] = useState("");
    const [paginationFlag, setPaginationFlag] = useState(false);
    const [selectedYear, setSelectedYear]: any = useState();
    // action dispatch
    const dispatch = useDispatch();
    const requestAccountSummary = () => dispatch(TransactionActions.actionCreators.requestAccountSummary());
    const requestRecentTransactions = (offset: number, limit: string, bankAccountTypeId: string, startDate: string, endDate: string, accountId: string) =>
        dispatch(TransactionActions.actionCreators.requestRecentTransactions(offset, limit, bankAccountTypeId, startDate, endDate, accountId));
    const requestChartData = () => dispatch(TransactionActions.actionCreators.requestChartData());
    // useSelector
    const chartDataFromAPI = useSelector((state: ApplicationState) => {
        return state.transactionChartData.transactionChartData == null ? null : state.transactionChartData.transactionChartData.data;
    });
    const transactionDataFromSelector = useSelector((state: ApplicationState) => {
        return state.recentTransactionData.recentTransactionData == null ? null : state.recentTransactionData.recentTransactionData.data;
    });
    const numberOfRecord = useSelector((state: ApplicationState) => {
        return state.recentTransactionData.recentTransactionData == null || state.recentTransactionData.recentTransactionData.metadata == null
            ? 0
            : parseInt(state.recentTransactionData.recentTransactionData.metadata["num-total"], 10);
    });
    const summaryData = useSelector((state: ApplicationState) => {
        return {
            totalAccounts:
                state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null
                    ? null
                    : state.accountSummaryData.accountSummaryData["total-accounts"] == null
                    ? 0
                    : parseInt(state.accountSummaryData.accountSummaryData["total-accounts"].toString()),
            monthTransactions:
                state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null
                    ? 0
                    : state.accountSummaryData.accountSummaryData["month-transactions"] == null
                    ? 0
                    : parseInt(state.accountSummaryData.accountSummaryData["month-transactions"].toString()),
            monthAlerts:
                state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null
                    ? 0
                    : state.accountSummaryData.accountSummaryData["month-alerts"] == null
                    ? 0
                    : parseInt(state.accountSummaryData.accountSummaryData["month-alerts"].toString()),
            accountData:
                state.accountSummaryData == null || state.accountSummaryData.accountSummaryData == null ? [] : state.accountSummaryData.accountSummaryData["data"],
        };
    });
    useEffect(() => {
        if (transactionDataFromSelector == null || transactionDataFromSelector.length <= 0) {
            setSelectedYear(0);
            setFilterStartDate(minFilterDate);
            setFilterEndDate(maxFilterDate);
        }
    }, [transactionDataFromSelector]);

    const filterTypes = useSelector((state: ApplicationState) => {
        let filterList: any = ["All Account Types"];
        if (state.accountSummaryData && state.accountSummaryData.accountSummaryData && state.accountSummaryData.accountSummaryData.data)
            filterList.push(...state.accountSummaryData.accountSummaryData.data.map((accountSummeryElement: any) => accountSummeryElement["account-type"]));
        return filterList?.filter(function (item: number, index: number) {
            return filterList.indexOf(item) === index;
        });
    });

    const ensureDataFetched = () => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        requestAccountSummary();
        requestRecentTransactions(currentPageNo, pageSize.toString(), selectedBankAccountTypeId, filterStartDate, filterEndDate, filterAccountId);
    };

    const clearFilter = () => {
        setSelectedYear(0);
        setCurrentPageNo(1);
        let element: any = document.getElementById("filter-accounts");
        element.value = "All";
        let element1: any = document.getElementById("filter-type");
        element1.value = "";
        let element2: any = document.getElementById("filter-date-range");
        element2.value = "All";
        let element3: any = document.getElementById("filter-date-year");
        element3.value = "All";
        setSelectedBankAccountTypeId("");
        setFilterAccountId("");
        setFilterStartDate(minFilterDate);
        setFilterEndDate(maxFilterDate);
        requestRecentTransactions(1, pageSize.toString(), "", "", "", "");
        setPaginationFlag(!paginationFlag);
    };

    const mxServiceList = [ezsServiceIds.financialTransactionMonitoringMX];
    const ismxServiceActive = useAreServicesActive(mxServiceList) || enableMXForIDF;

    useEffect(ensureDataFetched, []);

    // transaction-not-mine dialog close from common dialog component
    const closeTransactionNotMineDialog = () => {
        setShowTransactionNotMineDialog(false);
    };

    // handle transaction-not-mine dialog open/close/cancel
    const handleTransactionNotMineDialog = (value: string): any => {
        if (value === "show") {
            setShowTransactionNotMineDialog(true);
            if (isNotMine) {
                window.addToDataLayer({ event: "Mark Transaction as Mine" });
            } else {
                window.addToDataLayer({ event: "Mark Transaction as Not Mine" });
            }
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowTransactionNotMineDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowTransactionNotMineDialog(false);
            let offset = (currentPageNo - 1) * pageSize;
            requestRecentTransactions(offset, pageSize.toString(), selectedBankAccountTypeId, filterStartDate, filterEndDate, filterAccountId);
            requestChartData();
        }
    };

    const filterRecentTransactionAccountType = (event: any): any => {
        setCurrentPageNo(1);
        let offset = 0;
        requestRecentTransactions(offset, pageSize.toString(), event.currentTarget.value, filterStartDate, filterEndDate, filterAccountId);
        setSelectedBankAccountTypeId(event.currentTarget.value);
        setPaginationFlag(!paginationFlag);
    };

    const filterRecentTransactionAccount = (event: any): any => {
        setCurrentPageNo(1);
        var accountId = event.currentTarget.value;
        let offset = 0;
        requestRecentTransactions(offset, pageSize.toString(), selectedBankAccountTypeId, filterStartDate, filterEndDate, accountId);
        setFilterAccountId(accountId);
        setPaginationFlag(!paginationFlag);
    };

    const [monthsData, setMonthsData]: any = useState([]);

    useEffect(() => {
        services.getTransactionMonths().then((data: any) => {
            setMonthsData(data);
        });
        return () => {
            sessionStorage.removeItem('listId');
        };
    }, []);

    const setAriaAttributes = () => {
        const selectElement = document.querySelector('.ant-select-selection-search-input');
        if (selectElement) {
            const selectElementId = selectElement.getAttribute('id');
            const ariaControlVal = selectElement.getAttribute('aria-controls');
            let listElement;
            const listIdFromSession = sessionStorage.getItem('listId');
            if (ariaControlVal !== selectElementId) {
                listElement = ariaControlVal ? document.getElementById(ariaControlVal) : null;
                sessionStorage.setItem('listId', ariaControlVal)
            } else {
                listElement = listIdFromSession ? document.getElementById(listIdFromSession) : null;
            }
            if (selectElementId && ariaControlVal) {
                if (listElement) {
                    selectElement.setAttribute('aria-controls', listIdFromSession);
                    return true;
                } else {
                    selectElement.setAttribute('aria-controls', selectElementId);
                }
            }
            return false;
        }
    };

    const handleClickEvent = () => {
        const listElementFound = setAriaAttributes();
        if (listElementFound) {
            document.removeEventListener('click', handleClickEvent);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            const listElementFoundInitially = setAriaAttributes();
            if (!listElementFoundInitially) {
                document.addEventListener('click', handleClickEvent);
            }
        }, 500);
        const classList = ["ant-pagination-item", "ant-pagination-jump-next", "ant-pagination-next", "ant-pagination-prev", "ant-pagination-jump-prev", "ant-pagination-options"];
        let elements: any[] = [];

        classList.forEach((className) => {
            const elementsWithClass = document.getElementsByClassName(className);

            elements = elements.concat(Array.from(elementsWithClass));
        });
        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const listItem = el;
                    if (listItem) {
                        listItem.setAttribute("role", "listitem");
                    }
                }
            } catch {}
        }
        const divWithAriaLabel = document.querySelectorAll('div[aria-label]');
        if (divWithAriaLabel.length > 0) {
            for (const el of divWithAriaLabel) {
                const divElement = el;
                if (divElement) {
                    divElement.setAttribute("role", "region");
                }
            }
        }

        const svgElementPrev = document.querySelector('li.ant-pagination-prev svg');
        if (svgElementPrev) {
            svgElementPrev.setAttribute("aria-label", "Left");
        }

        const svgElementNext = document.querySelector('li.ant-pagination-next svg');
        if (svgElementNext) {
            svgElementNext.setAttribute("aria-label", "Right");
        }

        return () => {
            document.removeEventListener('click', handleClickEvent);
        };

    }, [paginationFlag, numberOfRecord]);

    const filterRecentTransactionMonth = (event: any): any => {
        function checkMonth(m: string) {
            return m === month;
        }
        let offset = 0;
        setCurrentPageNo(1);
        if (event.currentTarget.value === "All") {
            let startDate = moment([selectedYear]);
            let endDate = moment([selectedYear]).endOf("year");
            const format = "YYYY-MM-DD";
            requestRecentTransactions(
                offset,
                pageSize.toString(),
                selectedBankAccountTypeId,
                moment(startDate).format(format),
                moment(endDate).format(format),
                filterAccountId
            );
            setFilterStartDate(moment(startDate).format(format));
            setFilterEndDate(moment(endDate).format(format));
        } else {
            let res = event.currentTarget.value.split(" ");
            var month = res[0];
            let theMonths = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
            let monthNum = theMonths.findIndex(checkMonth);
            
            let yearNum = parseInt(!!selectedYear ? selectedYear : res[1], 10);
            const numDaysInMonth = moment.utc([yearNum, monthNum + 1], "YYYY-MM").daysInMonth();
            let startDate = moment([yearNum, monthNum, 1]).utcOffset(5).toDate();
            let endDate = moment([yearNum, monthNum, numDaysInMonth, 23, 59, 59]).utcOffset(5).toDate();
            const format = "YYYY-MM-DD";
            requestRecentTransactions(
                offset,
                pageSize.toString(),
                selectedBankAccountTypeId,
                moment(startDate).format(format),
                moment(endDate).format(format),
                filterAccountId
            );

            setFilterStartDate(moment(startDate).format(format));
            setFilterEndDate(moment(endDate).format(format));
        }
        setPaginationFlag(!paginationFlag);
    };

    const filterRecentTransactionYear = (event: any): any => {
        let element2: any = document.getElementById("filter-date-range");
        element2.value = "All";
        let offset = 0;
        setCurrentPageNo(1);
        if (event.currentTarget.value === "All") {
            setSelectedYear(0);
            requestRecentTransactions(offset, pageSize.toString(), selectedBankAccountTypeId, minFilterDate, maxFilterDate, filterAccountId);
            setFilterStartDate(minFilterDate);
            setFilterEndDate(maxFilterDate);
        } else {
            var res = event.currentTarget.value.split(" ");
            setSelectedYear(res);
            let yearNum = parseInt(res);
            var startDate = moment([yearNum]);
            var endDate = moment([yearNum]).endOf("year");
            const format = "YYYY-MM-DD";
            requestRecentTransactions(
                offset,
                pageSize.toString(),
                selectedBankAccountTypeId,
                moment(startDate).format(format),
                moment(endDate).format(format),
                filterAccountId
            );
            setFilterStartDate(moment(startDate).format(format));
            setFilterEndDate(moment(endDate).format(format));
        }
        setPaginationFlag(!paginationFlag);
    };

    const showPagedRecord = (paginationPageNo: number, perPageSize: number) => {
        setPaginationFlag(!paginationFlag);
        // pageSize = perPageSize;
        setPageSize(perPageSize);
        setCurrentPageNo(paginationPageNo);
        let offset = (paginationPageNo - 1) * perPageSize;
        requestRecentTransactions(offset, perPageSize.toString(), selectedBankAccountTypeId, filterStartDate, filterEndDate, filterAccountId);
    };

    const getMonthdropdownOption = () => {
        const monthsAbbr = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
        const options: any = [];
        const filteredArr = monthsData.filter((month: any) => month.includes(selectedYear));
        if (filteredArr && filteredArr.length > 0) {
            for (let month of filteredArr) {
                const monthStr = month.split("/")[0] ? monthsAbbr[Number(month.split("/")[0]) - 1] : "";
                // const filterStr = monthStr + " " + (month.split("/")[1] ? month.split("/")[1] : "");
                options.push(monthStr);
            }
        }
        return options;
    };

    const getYearDropdownOption = () => {
        const monthsAbbr = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
        const options: any = [];
        if (monthsData && monthsData.length > 0) {
            for (let month of monthsData) {
                const yearStr = month.split("/")[1] ? Number(month.split("/")[1]) : "";
                if (options.indexOf(yearStr) < 0) options.push(yearStr);
            }
        }
        return options;
    };

    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="col-xs">
                    {summaryData != null && summaryData.totalAccounts !== -1 ? (
                        <React.Fragment>
                            {summaryData.totalAccounts === 0 ? (
                                <div className="box">
                                    <div className="box-header col-xs-12 col-sm-12" style={{ backgroundColor: "#F4F4F4" }}>
                                        <div className="content-sub-title text-align-center">
                                            <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                <em className="las la-exclamation-circle "></em>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content text-align-center">
                                        <div className="msg-generic">No accounts are currently being monitored.</div>
                                        <div className="msg-generic">These can be added using the "Add Account" button on the Financial Accounts tab.</div>
                                        <div className="msg-generic">
                                            <Link
                                                to="transactions/financial-account"
                                                onClick={() => {
                                                    window.addToDataLayer({ event: "Add Financial Account" });
                                                }}
                                                className="btn-default btn-primary fin-btn"
                                            >
                                                Financial Accounts
                                            </Link>
                                            <div className="space-divider margin-top-l" />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div className="box">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="row between-xs">
                                                    <div className="col-xs col-sm-12 col-no-gutter">
                                                        <div className="content-sub-title" id="label-scanned-transactions">
                                                            Scanned Transactions
                                                        </div>
                                                    </div>
                                                    <div className="col-xs col-sm-12 col-no-gutter flex-grow-null">
                                                        <div role="region" className="emphasize-4" id="count-scanned-transactions" aria-labelledby="label-scanned-transactions">
                                                            {summaryData.monthTransactions}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {!ismxServiceActive && (
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="row between-xs">
                                                        <div className="col-xs col-sm-12 col-no-gutter">
                                                            <div className="content-sub-title" id="label-flagged">
                                                                <em className="las la-flag"></em> Flagged
                                                            </div>
                                                        </div>
                                                        <div className="col-xs col-sm-12 col-no-gutter flex-grow-null">
                                                            <div role="region" className="emphasize-4" id="count-flagged" aria-labelledby="label-flagged">
                                                                {summaryData.monthAlerts}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="row between-xs">
                                                    <div className="col-xs col-sm-12 col-no-gutter">
                                                        <div className="content-sub-title" id="label-accounts">
                                                            Accounts
                                                        </div>
                                                    </div>
                                                    <div className="col-xs col-sm-12 col-no-gutter flex-grow-null">
                                                        <div role="region" className="emphasize-4" id="count-accounts" aria-labelledby="label-accounts">
                                                            {summaryData.totalAccounts}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box">
                                        <div className="box-content">
                                            <div className="between-xs between-sm">
                                                <div className="col-xs flex-grow-null col-sm col-no-gutter">
                                                    <h3 className="content-sub-title">Recent Transactions</h3>
                                                </div>
                                                <div className="col-xs-12 col-sm flex-grow-null col-no-gutter">
                                                    <div className="l-filters" id="filters">
                                                        <div className="row" id="filter-content">
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null ">
                                                                <div className="form-row no-margin">
                                                                    <div className="form-label  ">
                                                                        <label htmlFor="filter-type">Select Account Type</label>
                                                                    </div>
                                                                    <div className="form-input ">
                                                                        <select
                                                                            className="inputbox"
                                                                            id="filter-type"
                                                                            placeholder="Account Type"
                                                                            onChange={(e) => filterRecentTransactionAccountType(e)}
                                                                        >
                                                                            {filterTypes.map((acc: any) => {
                                                                                return (
                                                                                    <option value={acc == "All Account Types" ? "" : acc} key={acc}>
                                                                                        {acc?.replace(/_/g, " ")}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null ">
                                                                <div className="form-row no-margin">
                                                                    <div className="form-label  ">
                                                                        <label htmlFor="filter-accounts">Select Account</label>
                                                                    </div>
                                                                    <div className="form-input">
                                                                        <select
                                                                            className="inputbox"
                                                                            id="filter-accounts"
                                                                            placeholder="Select Account"
                                                                            onChange={(e) => filterRecentTransactionAccount(e)}
                                                                        >
                                                                            <option value="All" key="AllAC99">
                                                                                All Accounts
                                                                            </option>
                                                                            {summaryData.accountData != null &&
                                                                                summaryData.accountData.map((accData, index) => {
                                                                                    return (
                                                                                        <option
                                                                                            value={accData["account-id"]}
                                                                                            key={accData["account-id"] + index.toString()}
                                                                                        >
                                                                                            {accData["account-nickname"] != null &&
                                                                                            accData["account-nickname"] !== ""
                                                                                                ? accData["account-nickname"]
                                                                                                : accData["account-name"]}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {ismxServiceActive && <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                                                <div className="form-row no-margin">
                                                                    <div className="form-label  ">
                                                                        <label htmlFor="filter-date-year">Select Year</label>
                                                                    </div>

                                                                    {ismxServiceActive ? (
                                                                        <div className="form-input">
                                                                            <select
                                                                                className="inputbox"
                                                                                id="filter-date-year"
                                                                                onChange={(e) => filterRecentTransactionYear(e)}
                                                                            >
                                                                                <option value="All" key="AllYears">
                                                                                    All Years
                                                                                </option>
                                                                                {transactionDataFromSelector != null &&
                                                                                    getYearDropdownOption().map((item: string, index: number) => {
                                                                                        return (
                                                                                            <option value={item} key={"period-" + index.toString()}>
                                                                                                {item}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-input">
                                                                            <select
                                                                                className="inputbox"
                                                                                id="filter-date-range"
                                                                                onChange={(e) => filterRecentTransactionYear(e)}
                                                                            >
                                                                                <option value="All" key="AllMonths">
                                                                                    All Years
                                                                                </option>
                                                                                {chartDataFromAPI != null &&
                                                                                    chartDataFromAPI.reverse().map((accData, index) => {
                                                                                        return (
                                                                                            <option
                                                                                                value={accData.month.substr(0, 3) + " " + accData.year}
                                                                                                key={"period" + index.toString()}
                                                                                            >
                                                                                                {accData.month.substr(0, 3) + " " + accData.year}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>}
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                                                <div className="form-row no-margin">
                                                                    <div className="form-label  ">
                                                                        <label htmlFor="filter-date-range">Select Month</label>
                                                                    </div>

                                                                    {ismxServiceActive ? (
                                                                        <div className="form-input">
                                                                            <select
                                                                                className="inputbox"
                                                                                id="filter-date-range"
                                                                                onChange={(e) => filterRecentTransactionMonth(e)}
                                                                                disabled={!!!selectedYear}
                                                                            >
                                                                                <option value="All" key="AllMonths">
                                                                                    All Months
                                                                                </option>
                                                                                {transactionDataFromSelector != null &&
                                                                                    getMonthdropdownOption().map((item: string, index: number) => {
                                                                                        return (
                                                                                            <option value={item} key={"period-" + index.toString()}>
                                                                                                {item}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-input">
                                                                            <select
                                                                                className="inputbox"
                                                                                id="filter-date-range"
                                                                                onChange={(e) => filterRecentTransactionMonth(e)}
                                                                            >
                                                                                <option value="All" key="AllMonths">
                                                                                    All Months
                                                                                </option>
                                                                                {chartDataFromAPI != null &&
                                                                                    chartDataFromAPI.reverse().map((accData, index) => {
                                                                                        return (
                                                                                            <option
                                                                                                value={accData.month.substr(0, 3) + " " + accData.year}
                                                                                                key={"period" + index.toString()}
                                                                                            >
                                                                                                {accData.month.substr(0, 3) + " " + accData.year}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                                                <div>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        style={{ marginTop: "45px" }}
                                                                        onClick={() => clearFilter()}
                                                                        className="default_link"
                                                                    >
                                                                        Clear All Filters
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="margin-vertical-s"></div>

                                            <div
                                                className={`table-container scroll  ${
                                                    transactionDataFromSelector != null && transactionDataFromSelector.length == 0 && "loading"
                                                }`}
                                            >
                                                <div className="ant-table">
                                                    <div className="ant-table-container">
                                                        <div className="ant-table-content">
                                                            <table style={{ tableLayout: "auto" }}>
                                                                <thead className="ant-table-thead">
                                                                    <tr>
                                                                        <th className="ant-table-cell">Date</th>
                                                                        <th className="ant-table-cell">Description</th>
                                                                        <th className="ant-table-cell">Account</th>
                                                                        <th className="ant-table-cell">Account #</th>
                                                                        <th className="ant-table-cell">Category</th>
                                                                        <th className="ant-table-cell">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                {transactionDataFromSelector != null ? (
                                                                    <tbody className="ant-table-tbody">
                                                                        {transactionDataFromSelector.length > 0 ? (
                                                                            <React.Fragment>
                                                                                {transactionDataFromSelector.map((transaction: ItransactionData, index: number) => {
                                                                                    return (
                                                                                        <tr
                                                                                            className={
                                                                                                "ant-table-row ant-table-row-level-0" +
                                                                                                (transaction["is-fraudulent-transaction"] === "1"
                                                                                                    ? "ant-table-row-selected status-not-mine"
                                                                                                    : transaction["is-triggered-alert"] === "1"
                                                                                                    ? " status-alert"
                                                                                                    : "")
                                                                                            }
                                                                                            key={"recent-transaction-id-" + index}
                                                                                        >
                                                                                            <td className="ant-table-cell" style={{ whiteSpace: "nowrap" }}>
                                                                                                {getFormattedDate(
                                                                                                    i18nService.get("Country"),
                                                                                                    transaction["transaction-date"]
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="ant-table-cell">{transaction["description"]}</td>
                                                                                            <td className="ant-table-cell" style={{ whiteSpace: "nowrap" }}>
                                                                                                {transaction["account-nickname"] != null &&
                                                                                                transaction["account-nickname"] !== ""
                                                                                                    ? transaction["account-nickname"]
                                                                                                    : transaction["account-name"]}
                                                                                            </td>
                                                                                            <td className="ant-table-cell">
                                                                                                {transaction["account-number"]
                                                                                                    ? `${"X".repeat(
                                                                                                          transaction["account-number"].substr(
                                                                                                              0,
                                                                                                              transaction["account-number"].length - 4
                                                                                                          ).length
                                                                                                      )}${transaction["account-number"].substr(
                                                                                                          transaction["account-number"].length - 4
                                                                                                      )}`
                                                                                                    : ""}
                                                                                            </td>
                                                                                            <td className="ant-table-cell">{transaction["category-name"]}</td>
                                                                                            <td className="ant-table-cell" style={{ whiteSpace: "nowrap" }}>
                                                                                                {transaction["transaction-type"] &&
                                                                                                    transaction["transaction-type"].toLowerCase() === "credit"
                                                                                                    ? "+ "
                                                                                                    : "- "}
                                                                                                {"$" + transaction["amount"]}
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </React.Fragment>
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan={7}>
                                                                                    <div className="box">
                                                                                        <div className="box-content text-align-center">
                                                                                            There are no transactions in your currently selected filter. Try
                                                                                            updating your filter criteria.
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody className="ant-table-tbody">
                                                                        <tr>
                                                                            <td colSpan={7}>
                                                                                <div className="box">
                                                                                    <div className="box-content text-align-center">
                                                                                        There are no transactions in your currently selected filter. Try updating
                                                                                        your filter criteria.
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                {numberOfRecord != null && numberOfRecord > 0 ? (
                                                    <Pagination
                                                        total={numberOfRecord}
                                                        current={currentPageNo}
                                                        defaultCurrent={currentPageNo}
                                                        onChange={showPagedRecord}
                                                        showQuickJumper
                                                        pageSizeOptions={[10, 25, 50]}
                                                        defaultPageSize={pageSize}
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ) : (
                        <div className="box loading"></div>
                    )}
                </div>
            </div>
            {showTransactionNotMineDialog && (
                <DialogComponent dialogId="dialog-set-transaction-not-mine" title="Transaction not mine" closeDialog={closeTransactionNotMineDialog}>
                    <TransactionNotMineDialog transaction={transaction} isNotMine={isNotMine} closeDialog={handleTransactionNotMineDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default TransactionActivity;
